import { TextField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconPlus } from '@calendly/ui/components/glyphs/IconPlus';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useState } from 'react';
const addNoteButtonWrapperCss = "aoe0rjl";
export const NoteField = ({
  fieldNamePrefix
}) => {
  const fieldName = `${fieldNamePrefix}.additionalInfo`;
  const [{
    value
  }] = useFormField({
    name: fieldName
  });
  const [isExpanded, setIsExpanded] = useState(Boolean(value));
  if (isExpanded) {
    return <TextField name={fieldName} label={I18n.t('publisher.event_type_editor_crud.meeting_details.location.note_field_label')} placeholder={I18n.t('publisher.event_type_editor_crud.meeting_details.location.note_field_placeholder')} size="medium" type="textarea" requiredMark="optional" maxLength={255} />;
  }
  return <div className={addNoteButtonWrapperCss}>
      <Button appearance="ghost" size="small" onClick={() => setIsExpanded(true)}>
        <UiIcon icon={IconPlus} size="small" title="" />
        {I18n.t('publisher.event_type_editor_crud.meeting_details.location.add_note_button_label')}
      </Button>
    </div>;
};

require("./note_field.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./note_field.js");